@use "variables" as *;
@use "../../shared/styles/ListItemStyles.scss";

.selectWrapper {
  margin-top: $spacing-1;
  width: 50%;
}
